import {inject, Inject, Injectable} from '@angular/core';
import {UserService, UserTableSettingsDto} from '../../modules/apiModule1';
import {map} from 'rxjs/operators';
import {USER_TABLE_POSTFIX, USER_TABLE_SORT_POSTFIX, USER_TABLE_SORT_SEPARATED_POSTFIX} from '../../app.config';
import {Sort} from '@angular/material/sort';
import {StorageService} from "./storage.service";

@Injectable({
    providedIn: 'root'
})
export class UserTableSettingsService {

    storageService = inject(StorageService)
    constructor(
        private userService: UserService,
        @Inject(USER_TABLE_POSTFIX) private tablePostfix: string,
        @Inject(USER_TABLE_SORT_POSTFIX) private tableSortPostfix: string,
        @Inject(USER_TABLE_SORT_SEPARATED_POSTFIX) private userTableSortSeparatedPostfix: string,
    ) {
    }

    init() {
        this.userService.apiUserTablesettingsGet({})
            .pipe(map(v => v.values))
            .subscribe((v: UserTableSettingsDto[]) => {
                v.forEach((item) => {
                    const {tableCode, tablesList, sort} = item;

                    if (!tableCode || !tableCode.endsWith(this.tablePostfix) ) return;
                    const tableData = {key: tableCode, value: tablesList};
                    this.storageService.setItem(tableData.key, JSON.stringify(tableData.value));
                    const sortData = {
                        key: tableCode.replace(this.tablePostfix, this.tableSortPostfix),
                        value: {active: sort?.columnName, direction: sort?.ascending ? 'asc' : 'desc'}
                    };

                    this.storageService.setItem(sortData.key, JSON.stringify(sortData.value));
                })
            })
    }

    saveOrders(resource: string, value: string[]) {
        console.log('save', resource, value);
        if(resource === 'report-general'+this.tablePostfix) return;
        const params: UserTableSettingsDto = {
            tableCode: resource,
            tablesList: value
        };
        this.userService.apiUserTablesettingsPut({apiUserTablesettingsPutRequest: params}).subscribe()
    };

    saveSorting(resource: string, value: Sort) {
        if(!value || !value.direction || !value.active) return;
        const params: UserTableSettingsDto = {
            tableCode: resource.replace(this.tableSortPostfix, this.tablePostfix),
            sort: {
                columnName: value.active,
                ascending: value.direction === 'asc'
            },
            tablesList: JSON.parse(window.localStorage.getItem(resource.replace(this.tableSortPostfix, this.tablePostfix)) ?? '')
        };
        this.userService.apiUserTablesettingsPut({apiUserTablesettingsPutRequest: params}).subscribe()
    };

}
